import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { ComplianceLink } from './Compliance/ComplianceLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Footer = () => /*#__PURE__*/_jsxs(View, {
  as: "footer",
  flexShrink: 0,
  marginBlock: "400",
  textAlign: "center",
  children: [/*#__PURE__*/_jsxs(Text, {
    as: "span",
    typography: "detail-100",
    children: ["\xA9", new Date().getFullYear(), " HubSpot, Inc.", ' ', /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.footer.allRightsReserved"
    })]
  }), /*#__PURE__*/_jsxs(View, {
    as: "span",
    typography: "detail-100",
    children: [/*#__PURE__*/_jsx(Link, {
      href: "https://legal.hubspot.com/privacy-policy",
      marginInlineStart: "300",
      marginInlineEnd: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.footer.privacy"
      })
    }), /*#__PURE__*/_jsx(ComplianceLink, {})]
  })]
});